import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { useApp } from 'hooks/selectors';

import media from '../../theme/media';
import zindex from '../../theme/zIndex';
import { Row } from '../common/Layout/Row';
import { SpinnerCircle } from '../common/SpinnerCircle/SpinnerCircle';
import { Text } from '../common/Text/Text';

const SpinnerOverlay = styled.div`
    bottom: 0;
    left: 0;
    min-width: 288px;
    overflow: auto;
    position: ${(props) => (props.insidePopup ? 'absolute' : 'fixed')};
    right: 0;
    top: 0;
    background-color: ${(props) => (props.insideChat ? 'transparent' : props.theme.white_96_tr)};
    z-index: ${zindex.spinnerOverlay};
`;
const SpinnerContainer = styled.div`
    /* content width 480 */
    max-width: 528px;
    box-sizing: border-box;
    padding: 128px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
    margin: 0 auto;

    ${media.tablet720} {
        /* content width 504px */
        max-width: 552px;
    }
`;

const Spinner = ({ forceShow = false, ...props }) => {
    const { isMobileBrowser } = useApp();

    useEffect(() => {
        if ((props.isShowSpinner || forceShow) && isMobileBrowser) {
            if (document.activeElement && document.activeElement.tagName === 'INPUT') {
                const focusedInput = document.activeElement;
                setTimeout(() => {
                    focusedInput.blur();
                }, 1000);
            }
        }
    }, [props.isShowSpinner, forceShow]);

    if (props.isShowSpinner || forceShow) {
        return (
            <SpinnerOverlay insidePopup={props.insidePopup}>
                <SpinnerContainer>
                    <Row indent={props.isEmptyText ? '0' : '24px'}>
                        <SpinnerCircle />
                    </Row>
                    {!props.isEmptyText && <Text variant="paragraph">{props.customSpinnerText ? props.customSpinnerText : props.siteSpinnerText}</Text>}
                </SpinnerContainer>
            </SpinnerOverlay>
        );
    } else {
        return false;
    }
};
Spinner.propTypes = {
    insidePopup: PropTypes.bool,
    isEmptyText: PropTypes.bool,
    customSpinnerText: PropTypes.string,
};
const mapStateToProps = (state) => {
    return {
        isShowSpinner: state.app.isShowSpinner,
        siteSpinnerText: state.messages?.pageMessages?.siteSpinnerText,
    };
};

export default connect(mapStateToProps)(Spinner);
